import { menuManagerModule } from './views/menuManager/module';
import { state } from './models';
import { getters } from './getters';
import { mutations } from './mutations';
import * as actions from './actions';
import { priceManagerModule } from './views/priceManager/module';

export const optimizerProModule = {
  state,
  getters,
  actions,
  mutations,
  modules: {
    priceManager: priceManagerModule,
    menuManager: menuManagerModule,
  },
};
